import React, { useState } from "react";
import styles from "../style/YoutubeGrid.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";

const YoutubeGrid = () => {
  const slider = React.useRef(null);

  const videoData = [
    {
      title: "Does Lamaan treat all my teeth?",
      src: "https://www.youtube.com/embed/14z8m0lnUog",
      answer:
        "Our aligners work on aligning your front 8 teeth on both the top and bottom arches. Our invisible aligners do not move molars or wisdom teeth. The treatment does not treat jaw or bite issues but sometimes bite corrections are a result of invisible aligner treatments.",
    },
    {
      title: "Does Lamaan replace conventional braces?",
      src: "https://www.youtube.com/embed/kLxqINKs-EI",
      answer:
        "HealthFlow aligners are an alternative to the conventional metallic braces if you have mild to moderate crowding or spacing issues. Each step in your invisible aligner treatment will move your teeth closer to their final position.",
    },
    {
      title: "What are Lamaan aligners made of?",
      src: "https://www.youtube.com/embed/atbtxJeIELE",
      answer:
        "HealthFlow aligners are made from comfortable and transparent FDA-Approved medical grade plastic sourced from the USA and Germany. They are stronger, more hygienic, and more durable than any other aligners on the market today.",
    },
    {
      title: "How reliable is Lamaan treatment?",
      src: "https://www.youtube.com/embed/dJb9zIZuay8",
      answer:
        "We only treat cases that our orthodontists think are the right fit. Our orthodontists design your treatment plan and we’ll show you a 3D view of how your teeth will change during the treatment. Each aligner in your plan is a step designed in advance, so our orthodontists can continuously monitor your progress to ensure your treatment is going as planned.",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [showAnswers, setShowAnswers] = useState(
    Array(videoData.length).fill(false)
  );

  const toggleAnswer = (index) => {
    setShowAnswers(showAnswers.map((show, i) => (i === index ? !show : show)));
  };

  return (
    <>
      {/* <h2 className={styles.title}>You asked, we're answering</h2> */}
      <div className={styles.gridContainer}>
        {/* <Slider {...settings} ref={slider}>
          {videoData.map((video, index) => (
            <div key={index} className={styles.gridItem}>
              <div key={index} className={styles.videoWrapper}>
                <iframe
                  className={styles.video}
                  src={video.src}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <div className={styles.TextWrapper}>
                  <h3 className={styles.videoTitle}>{video.title}</h3>
                  <button
                    className={styles.toggleButton}
                    onClick={() => toggleAnswer(index)}
                  >
                    {showAnswers[index] ? "Hide answer" : "Show answer"}
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                  {showAnswers[index] && (
                    <p className={styles.videoAnswer}>{video.answer}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider> */}
        {/* <div className={styles.buttonWrapper}>
          <button
            onClick={() => slider?.current?.slickPrev()}
            className={`${styles.customButton} ${styles.prevButton}`}
          >
            <FontAwesomeIcon icon={faChevronLeft} size="2x" />
          </button>
          <button
            className={`${styles.customButton} ${styles.nextButton}`}
            onClick={() => slider?.current?.slickNext()}
          >
            <FontAwesomeIcon icon={faChevronRight} size="2x" />
          </button>
        </div> */}
      </div>
    </>
  );
};

export default YoutubeGrid;
